import React, { useEffect, useState, useContext } from 'react';
import {
  CircularProgress,
  Container,
  Typography,
  Card,
  CardContent,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  Stack,
  Button,
  IconButton,
  Alert,
  Chip,
  Tooltip,
  Badge
} from '@mui/material';
import { Visibility, PictureAsPdf,Edit, Delete } from '@mui/icons-material';
import PaymentIcon from '@mui/icons-material/Payment'; // importa icona
import documentoApi from '../../api/documentoApi';
import scadenzaApi from '../../api/scadenzaApi';
import filesApi from '../../api/filesApi'; // ✅ import corretto
import { useParams, useNavigate } from 'react-router-dom';
import FileUpload from '../../components/FileUpload';
import ConfirmDialog from '../../components/ConfirmDeleteModal';
import { scadenzaStatusMap } from '../../utils/scadenzaStatusMapper';
import ProtectedAction from '../../components/ProtectedAction';
import BackButtonDesktop from '../../components/BackButtonDesktop';
import { AuthContext } from '../../auth/AuthContext';
import { formatDate } from '../../utils/dateFormatter';

export default function DocumentoDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { token } = useContext(AuthContext);
  const { user } = useContext(AuthContext);
  const [doc, setDoc] = useState(null);
  const [scadenze, setScadenze] = useState([]);
  const [scadPage, setScadPage] = useState(0);
  const [scadTotalPages, setScadTotalPages] = useState(0);
  const [openDelete, setOpenDelete] = useState(false);
  const [selectedScadId, setSelectedScadId] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const pageSize = 10;
  const isF24 = doc?.tipo === 'F24';
  const unicaScadenza = isF24 && scadenze.length === 1 ? scadenze[0] : null;
  /* ===================== LOAD ===================== */
  useEffect(() => {
    if (!id) {
      setError('ID documento mancante');
      return;
    }
    fetchDocumento();
    fetchScadenze(0);
  }, [id]);

  const fetchDocumento = async () => {
    if (!token) return;
    try {
      const r = await documentoApi.get(id);
      setDoc(r.data);
    } catch (e) {
      console.error('Errore caricamento documento', e);
      setError('Errore caricamento documento');
    }
  };

  const fetchScadenze = async (page = 0) => {
    if (!token) return;
    try {
      const r = await scadenzaApi.listbydocument(id, { page, size: pageSize });
      const data = r.data || {};
      setScadenze(data.content || []);
      setScadTotalPages(data.totalPages || 0);
      setScadPage(data.number || 0);
    } catch (e) {
      console.error('Errore caricamento scadenze', e);
      setScadenze([]);
      setScadTotalPages(0);
      setScadPage(0);
    }
  };

  /* ===================== UPLOAD ===================== */
  const onFile = async (file) => {
    if (!doc) return;
    try {
      console.log("upload");
      const fd = new FormData();
      fd.append('file', file);
      fd.append('doc', doc);
      fd.append('contribuenteId', doc.contribuente.id); // aggiunto
      await documentoApi.uploadPdf(id, fd);
      fetchDocumento();
    } catch (e) {
      console.error('Errore upload PDF', e);
      setError('Errore durante upload PDF');
    }
  };

  const openFile = async (filename, contribuenteId) => {
    try {
      const res = await filesApi.getfile(filename, contribuenteId);
      const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      window.open(url, '_blank');
    } catch (err) {
      console.error('Errore apertura PDF:', err);
    }
  };

    const handleDownload = async (documentoId, fileName) => {
      try {
        setLoading(true);
        const response = await documentoApi.downloadDocumento(documentoId, fileName);
        const url = window.URL.createObjectURL(
                              new Blob([response.data], { type: 'application/pdf' })
                            );
        window.open(url, '_blank');
      } catch (err) {
        console.error(err);
      } finally {
             setLoading(false);
           }
    };
  /* ===================== DELETE ===================== */
  const confirmDelete = (scadId) => {
    setSelectedScadId(scadId);
    setOpenDelete(true);
  };

  const handleDelete = async () => {
    try {
      await scadenzaApi.delete(selectedScadId);
      fetchScadenze(scadPage);
    } catch (e) {
      console.error('Errore eliminazione scadenza', e);
      setError('Errore eliminazione scadenza');
    } finally {
      setOpenDelete(false);
      setSelectedScadId(null);
    }
  };

  /* ===================== RENDER ===================== */
  if (error) {
    return (
      <Container sx={{ mt: 4 }}>
        <Alert severity="error">{error}</Alert>
      </Container>
    );
  }

  if (!doc) {
    return (
      <Container sx={{ mt: 4 }}>
        <Typography>Caricamento documento…</Typography>
      </Container>
    );
  }

  return (
    <Container>
                  {loading && (
                    <Box
                      sx={{
                        position: 'fixed',
                        inset: 0,
                        bgcolor: 'rgba(255,255,255,0.7)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 1300,
                      }}
                    >
                      <CircularProgress size={48}/>
                    </Box>
                  )}
             <BackButtonDesktop />
      <Typography variant="h4">{doc.tipo}</Typography>
      <Typography variant="h5">{doc.descrizione}</Typography>
      <Typography >Contribuente: {doc.contribuente?.nome} {doc.contribuente?.cognome}</Typography>
      {doc.numeroDocumento && <Typography>Numero Documento: {doc.numeroDocumento}</Typography>}
      {doc.dataDocumento && <Typography>Data Documento: {formatDate(doc.dataDocumento)}</Typography>}
      {doc.enteRiscossione && <Typography>Ente: {doc.enteRiscossione}</Typography>}
      <Typography>CF Contribuente: {doc.contribuente?.codiceFiscale}</Typography>
      <Typography>Indirizzo: {doc.contribuente?.indirizzo}</Typography>
      {doc.iuv && <Typography>IUV: {doc.iuv}</Typography>}
      {doc.cbill && <Typography>CBILL: {doc.cbill}</Typography>}
      <Card sx={{ mt: 2 }}>
        <CardContent>
          <Typography>Data creazione: {formatDate(doc.dataCreazione)}</Typography>
<Card sx={{ mt: 2 }}>
  <CardContent>
    <Typography>File caricati</Typography>
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Tipo</TableCell>
          <TableCell>Data Upload</TableCell>
          <TableCell>Azioni</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {/* PDF principale */}
        {doc.pdfPath && (
          <TableRow>
            <TableCell>Principale</TableCell>
            <TableCell>{formatDate(doc.dataCreazione)}</TableCell>
            <TableCell>
              <IconButton
                color="error"
                size="small"
                    onClick={() => handleDownload(doc.id, doc.pdfPath)}
              >
                <PictureAsPdf />
              </IconButton>
            </TableCell>
          </TableRow>
        )}

        {/* Altri file caricati */}
        {doc.files && doc.files.map((f) => (
          <TableRow key={f.id}>
            <TableCell>Allegato</TableCell>
            <TableCell>{new Date(f.uploadDate).toLocaleString()}</TableCell>
            <TableCell>
            <Tooltip title="download file">
              <IconButton
                color="error"
                size="small"
                    onClick={() => handleDownload(doc.id, f.filename)}
                >
                <PictureAsPdf />
              </IconButton>
              </Tooltip>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </CardContent>
</Card>
          <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
            {/* Bottone per upload PDF generico (potresti anche metterlo per ogni documento)
            <ProtectedAction user={user} contractState={user.statoContratto}>
            <Button variant="outlined" color="secondary" onClick={() => navigate(`/documenti/${id}/upload`)}>
              Upload PDF
            </Button></ProtectedAction>*/}
          </Stack>
          <Typography sx={{ mt: 1 }}>
            Rate saltate:{' '}
            {doc.rateSaltate > 0 ? (
              <Badge color="error" badgeContent={doc.rateSaltate}>
                <span />
              </Badge>
            ) : (
              doc.rateSaltate
            )}
          </Typography>


        </CardContent>
      </Card>

      <Typography variant="h6" sx={{ mt: 3 }}>
        Scadenze collegate
      </Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Tipo</TableCell>
            <TableCell>Rata</TableCell>
            <TableCell>Data</TableCell>
            <TableCell>Codice pagamento</TableCell>
            <TableCell>Importo</TableCell>
            <TableCell>File</TableCell>
            <TableCell>Stato</TableCell>
            <TableCell>Pagamento</TableCell>
            <TableCell>Marca come pagata</TableCell>
            <TableCell>Azioni</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {scadenze.map((s) => {
            const cfg = scadenzaStatusMap[s.stato];
            return (
              <TableRow key={s.id}>
                <TableCell>{s.tipo}</TableCell>
                <TableCell>{s.numerorata}</TableCell>
                <TableCell>{formatDate(s.dataScadenza)}</TableCell>
                <TableCell>{s.codiceModuloPagamento}</TableCell>
                <TableCell>{s.importo}</TableCell>
                <TableCell>
                {/* PDF  */}
                {s.pdfPath && (
                     <Tooltip title="download file">
                      <IconButton
                      color="error"
                      size="small"
                        onClick={() => handleDownload(doc.id, s.pdfPath)}
                      >
                        <PictureAsPdf />
                      </IconButton>
                      </Tooltip>
                )}
                </TableCell>
                <TableCell>
                  <Chip label={cfg?.label || s.stato} color={cfg?.color || 'default'} size="small" />
                </TableCell>
                <TableCell>{formatDate(s.dataPagamento)}</TableCell>
                <TableCell>
                { s.stato !== "pagata" && (
                  <Stack direction="row" spacing={1}>
                  <ProtectedAction user={user} contractState={user.statoContratto}>
                    <Tooltip title="marca come pagata">
                    <IconButton
                      size="small"
                      color="success"
                      onClick={async () => {
                        try {
                          // chiama rotta interna per marcare pagata senza email
                          await scadenzaApi.setpagatamanuale(s.id);
                          fetchScadenze(scadPage);
                        } catch (err) {
                          console.error('Errore marcatura manuale pagamento:', err);
                        }
                      }}
                    >
                      <PaymentIcon />
                    </IconButton></Tooltip></ProtectedAction>
                  </Stack>
                )}
                  </TableCell>
                <TableCell>
                  <Stack direction="row" spacing={1}>
                  <Tooltip title="dettaglio">
                    <IconButton color="primary" size="small" onClick={() => navigate(`/scadenze/${s.id}`)}>
                      <Visibility />
                    </IconButton>
                    </Tooltip>
                    {/*
                    <ProtectedAction user={user} contractState={user.statoContratto}>
                    <Tooltip title="modifica">
                    <IconButton color="secondary" size="small" onClick={() => navigate(`/scadenze/edit/${s.id}`)}>
                      <Edit />
                    </IconButton>
                    </Tooltip>
                    <Tooltip title="elimina">
                    <IconButton size="small" color="error" onClick={() => confirmDelete(s.id)}>
                      <Delete />
                    </IconButton></Tooltip></ProtectedAction>
                    */}
                  </Stack>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>

      <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
        {Array.from({ length: scadTotalPages }, (_, i) => (
          <Button
            key={i}
            variant={i === scadPage ? 'contained' : 'outlined'}
            onClick={() => fetchScadenze(i)}
          >
            {i + 1}
          </Button>
        ))}
      </Stack>
{isF24 && unicaScadenza?.tributi?.length > 0 && (
  <>
    <Typography variant="h6" sx={{ mt: 4 }}>
      Tributi F24
    </Typography>

    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>Codice Tributo</TableCell>
          <TableCell>Anno</TableCell>
          <TableCell align="right">Debito</TableCell>
          <TableCell align="right">Credito</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {unicaScadenza.tributi.map((t) => (
          <TableRow key={t.id}>
            <TableCell>{t.codiceTributo}</TableCell>
            <TableCell>{t.annoRiferimento}</TableCell>
            <TableCell align="right">{t.importoDebito}</TableCell>
            <TableCell align="right">{t.importoCredito}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </>
)}
      <ConfirmDialog
        open={openDelete}
        onCancel={() => setOpenDelete(false)}
        onConfirm={handleDelete}
        title="Elimina Scadenza"
        message="Sei sicuro di voler eliminare questa scadenza?"
      />
    </Container>
  );
}